import api from './api';
import StorageService from './StorageService';

const PayInService = {
    getAllPayIn: async (page = 1, limit = 10, filters = {}) => {
        try {
            const { branchId, staffId, memberId, vendorId, projectId, paymentMode, status, startDate, endDate } = filters;
            let url = `/pay-in?page=${page}&limit=${limit}`;
            if (branchId) url += `&branchId=${branchId}`;
            if (staffId) url += `&staffId=${staffId}`;
            if (memberId) url += `&memberId=${memberId}`;
            if (vendorId) url += `&vendorId=${vendorId}`;
            if (projectId) url += `&projectId=${projectId}`;
            if (paymentMode) url += `&paymentMode=${paymentMode}`;
            if (status) url += `&status=${status}`;
            if (startDate) url += `&startDate=${startDate}`;
            if (endDate) url += `&endDate=${endDate}`;

            const res = await api.get(url);
            return res.data;
        } catch (error) {
            if (error.response && error.response.data) {
                throw new Error(error.response.data.message || 'Failed to fetch pay-ins');
            }
            throw new Error('Unable to connect to server');
        }
    },

    getPayInById: async (id) => {
        try {
            const res = await api.get(`/pay-in/${id}`);
            return res.data;
        } catch (error) {
            if (error.response && error.response.data) {
                throw new Error(error.response.data.message || 'Failed to fetch pay-in');
            }
            throw new Error('Unable to connect to server');
        }
    },

    createPayIn: async (data) => {
        try {
            const payload = { ...data, createdBy: StorageService.loginData()?.employeeId };
            const res = await api.post('/pay-in', payload);
            return res.data;
        } catch (error) {
            if (error.response && error.response.data) {
                throw new Error(error.response.data.message || 'Failed to create pay-in');
            }
            throw new Error('Unable to connect to server');
        }
    },

    updatePayIn: async (id, data) => {
        try {
            const payload = { ...data, updatedBy: StorageService.loginData()?.employeeId };
            const res = await api.put(`/pay-in/${id}`, payload);
            return res.data;
        } catch (error) {
            if (error.response && error.response.data) {
                throw new Error(error.response.data.message || 'Failed to update pay-in');
            }
            throw new Error('Unable to connect to server');
        }
    },

    updateStatus: async (id, status) => {
        try {
            const res = await api.patch(`/pay-in/${id}/status`, { status, updatedBy: StorageService.loginData()?.employeeId });
            return res.data;
        } catch (error) {
            if (error.response && error.response.data) {
                throw new Error(error.response.data.message || 'Failed to update pay-in status');
            }
            throw new Error('Unable to connect to server');
        }
    }
};

export default PayInService;
